import { useUser } from 'libs/providers';

import { RegistrationPassword } from '../components/RegistrationPassword';
import { RegistrationPasswordFormType } from '../forms/registrationPasswordForm';
import { useRegistrationPasswordActivate } from '../hooks';
import { RegistrationStepProps } from '../types';

export const RegistrationPasswordActivateStep = ({
  canGoBack,
  onGoBack,
  onGoNext,
}: RegistrationStepProps) => {
  const { reUser } = useUser();
  const { onSubmit, loading, formError, passwordValidationRule } =
    useRegistrationPasswordActivate();

  const handleSubmit = async (values: RegistrationPasswordFormType) => {
    await onSubmit(values);
    reUser();
    onGoNext();
  };

  return (
    <RegistrationPassword
      canGoBack={canGoBack}
      formError={formError}
      passwordValidationRule={passwordValidationRule}
      submitLoading={loading}
      onGoBack={onGoBack}
      onSubmit={handleSubmit}
    />
  );
};
